import { InputHTMLAttributes, DetailedHTMLProps } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
interface ITimeInputProps
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
  secondDiv?: string;
  label?: string;
  register?: UseFormRegisterReturn;
  required?: boolean;
  onChange?: any;
  placeholder?: any;
}
const TimeInput: React.FC<ITimeInputProps> = ({
  type = "time",
  className = "border border-gray-300 col-span-2",
  secondDiv = "grid grid-cols-1 md:grid-cols-3",
  register,
  disabled = false,
  required,
  label,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      <div className={`${secondDiv} w-full items-center gap-1`}>
        {label && (
          <label className="flex space-x-1 justify-start expandedLabel fontExpand">
            {required && <div className="text-red-500 pr-0.5 font-bold">*</div>}
            {label}
          </label>
        )}
        <input
          className={`${className}  block w-full px-1 py-1 rounded-sm bg-white text-login bg-clip-padding 
          leading-normal outline-none focus:ring-septenary focus:border-septenary ${
            disabled && "opacity-50"
          }`}
          {...register}
          disabled={disabled}
          type={type}
          {...props}
        />
      </div>
    </div>
  );
};

export default TimeInput;
